/**
 * @(#)2019/6/17.
 * Number，输入数字或金额的组件
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { Component } from "react";
import ReactDOM from "react-dom";
import { InputNumber } from "antd";
import Basics from "./Basics";
import style from "./index.less";
import { cloneDeep } from "../../utils";
import { merge } from "lodash";
import { YxComponent, Connection } from "../YxComponent";
import { numberPropTypes } from "./IpropType/numberPropType";
/*
 * -----------------------公共部分参数--------------------------------------------------
 * @param children {number} 子节点，需要展示的内容
 * @param precision {number} 保留几位小数，默认0
 * @param rounding {boole} 是否开启四舍五入，默认开启，在处理千分位和小数点时有效
 * @param thousand {boole} 是否开启千分位处理，默认true
 * @param amountBeforeStr {string} 显示在前面的内容
 * @param amountAfterStr {string} 显示在后面的内容
 * @param min {number} 最小数字
 * @param max {number} 最大数字
 * */
//默认props
let defaul = () => {
  return {
    children: <InputNumber />, //子节点
    rules: {
      max: "",
    },
    inputParam: {}, //存给input的参数
    amountBeforeStr: "", //显示在前面的前缀
    amountAfterStr: "", //显示在后面的后缀
    precision: 0, //保留几位小数
    thousand: true, //是否开启千分位处理
    max: 100000000, //最大数字
    min: -100000000, //最小数字
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class YxNumber extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  //千分位处理,小数点处理
  thousand(tmpProps) {
    let prefix = tmpProps.amountBeforeStr;
    let cmpany = tmpProps.amountAfterStr;

    //处理千分位和小数
    if (tmpProps.thousand) {
      tmpProps.inputParam.formatter = (val) => {
        return `${prefix}${val}${cmpany}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
    }
    //tmpProps.inputParam.parser = (val)=> {
    //  return val.replace(/\$\s?|(,*)/g, '');
    //}
    return tmpProps;
  }

  productionHtml() {
    let tmpProps = this.props;
    //之所以这样做是为了解决引用地址一样导致参数重复的问题
    let inputParam = { ...tmpProps.inputParam };
    inputParam.max = tmpProps.max; //设置最大数字
    inputParam.min = tmpProps.min; //设置最小数字
    inputParam.precision = tmpProps.precision; //处理小数点
    const param = {
      inputParam,
    };
    //千分位处理
    tmpProps = this.thousand(merge(param, tmpProps));

    let classParam = {
      yx_yxNumber_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxNumber_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );

    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    //合并默认参数和外部参数
    return this.productionHtml();
  }
}
YxNumber.defaultProps = defaul();
YxNumber.propTypes = numberPropTypes;
export default YxNumber;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Number.js